"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryFromLocale = exports.getLanguageFromLocale = void 0;
function getLanguageFromLocale(locale) {
    return locale.split("-")[0];
}
exports.getLanguageFromLocale = getLanguageFromLocale;
var mapped = new Map([["en", "GB"]]);
function getCountryFromLocale(locale) {
    var _a;
    var components = locale.split("-");
    if (components.length > 1) {
        return components[1];
    }
    return (_a = mapped.get(components[0])) !== null && _a !== void 0 ? _a : components[0].toUpperCase();
}
exports.getCountryFromLocale = getCountryFromLocale;
